import script from "./RetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RetailPage.vue?vue&type=script&setup=true&lang=js"

import "./RetailPage.vue?vue&type=style&index=0&id=1807abeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1807abeb"]])

export default __exports__